(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection-spring"] && !Shopify.designMode) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["wave-spectrum"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function measure(el) {
      return el ? el.getBoundingClientRect().height : 0;
    }

    function collectDots(container) {
      var wraps = container.querySelectorAll('[data-pos]');
      var items = [];
      for (var i = 0; i < wraps.length; i++) {
        var wrap = wraps[i];
        var card = wrap.querySelector('[class*="wsp-vcard-row-"]');
        items.push({
          pos: parseFloat(wrap.getAttribute('data-pos')),
          height: measure(card)
        });
      }
      items.sort(function (a, b) {
        return a.pos - b.pos;
      });
      return items;
    }

    function minHeightForGaps(items, gap) {
      var minHeight = 0;
      for (var i = 0; i < items.length - 1; i++) {
        var deltaPct = (items[i + 1].pos - items[i].pos) / 100;
        if (deltaPct <= 0) continue;
        var needed = (items[i].height / 2 + items[i + 1].height / 2 + gap) / deltaPct;
        if (needed > minHeight) minHeight = needed;
      }
      return minHeight;
    }

    function layoutTrack(wrap) {
      var baseGap = parseFloat(wrap.getAttribute('data-base-gap')) || 24;
      var details = wrap.querySelector('[class*="wsp-vtrack-details-"]');
      var wasOpen = details ? details.open : null;
      if (details) details.open = true;

      var topOuter = wrap.querySelector('[class*="wsp-vtrack-top-"]:not([class*="-inner-"])');
      var topInner = wrap.querySelector('[class*="wsp-vtrack-top-inner-"]');
      if (topOuter && topInner) {
        var topItems = collectDots(topInner);
        var topLabelHeight = topItems.length ? topItems[topItems.length - 1].height : 0;
        topOuter.style.paddingBottom = Math.max(baseGap, topLabelHeight / 2 + baseGap) + 'px';
      }

      var bottomOuter = wrap.querySelector('[class*="wsp-vtrack-bottom-"]:not([class*="-inner-"])');
      var bottomInner = wrap.querySelector('[class*="wsp-vtrack-bottom-inner-"]');
      if (bottomOuter && bottomInner) {
        var bottomItems = collectDots(bottomInner);
        var bottomLabelHeight = bottomItems.length ? bottomItems[0].height : 0;
        bottomOuter.style.paddingTop = Math.max(baseGap, bottomLabelHeight / 2 + baseGap) + 'px';
      }

      var midOuter = wrap.querySelector('[class*="wsp-vtrack-mid-outer-"]');
      var midInner = wrap.querySelector('[class*="wsp-vtrack-mid-inner-"]');
      var midDots = wrap.querySelector('[class*="wsp-vtrack-mid-dots-"]');
      if (midOuter && midInner && midDots) {
        var midItems = collectDots(midDots);
        var midMinHeight = minHeightForGaps(midItems, baseGap);
        if (midMinHeight > 0) {
          midInner.style.height = midMinHeight + 'px';
          var varName = midOuter.getAttribute('data-mid-height-var');
          if (varName) {
            midOuter.style.setProperty(varName, midMinHeight + baseGap + 'px');
          }
        }
      }

      var fullTrack = wrap.querySelector('[data-wsp-vtrack-full]');
      if (fullTrack) {
        var fullItems = collectDots(fullTrack);
        var fullMinHeight = minHeightForGaps(fullItems, baseGap);
        var firstHalf = fullItems.length ? fullItems[0].height / 2 : 0;
        var lastHalf = fullItems.length ? fullItems[fullItems.length - 1].height / 2 : 0;
        var neededFullHeight = fullMinHeight + firstHalf + lastHalf;
        if (neededFullHeight > fullTrack.getBoundingClientRect().height) {
          fullTrack.style.height = neededFullHeight + 'px';
        }
      }

      if (details && wasOpen !== null) details.open = wasOpen;
    }

    function layoutAll() {
      var wraps = document.querySelectorAll('[data-wsp-vtrack]');
      for (var i = 0; i < wraps.length; i++) {
        layoutTrack(wraps[i]);
      }
    }

    var resizeTimer;
    function scheduleLayout() {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(layoutAll, 150);
    }

    if (document.readyState === 'complete') {
      layoutAll();
    } else {
      window.addEventListener('load', layoutAll);
    }
    window.addEventListener('resize', scheduleLayout);
  })();

  } catch(e) { console.error(e); }
})();
})();
